import { Component, OnInit } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { UtilsService } from "../../../../auth/service/utils.service";
import { AuthenticationService } from "../../../../auth/service";
import { locale as italian } from "../../../../i18n/it";
import { Router } from "@angular/router";
import { IContentHeader } from "../../../../layout/components/content-header/content-header.component";
import { ListService } from "../../../../auth/service/list.service";
interface IBillingFrequency {
  name: string;
  id?: number;
  other: { month_value: number };
}

@Component({
  selector: "app-billing-frequency-list",
  templateUrl: "./billing-frequency-list.component.html",
  styleUrls: ["./billing-frequency-list.component.scss"],
})
export class BillingFrequencyListComponent implements OnInit {
  public tableLimit: number = 10;
  public searchKeyword: string = "";
  public contentHeader: IContentHeader;
  public billingFrequency: IBillingFrequency = {
    name: null,
    other: {
      month_value: null,
    },
  };
  public billingFrequencyList: IBillingFrequency[] = [];
  public filteredBillingFrequencyList: IBillingFrequency[] = [];
  public showModalError: boolean = false;

  constructor(
    public _modalService: NgbModal,
    public _utilService: UtilsService,
    public _authenticationService: AuthenticationService,
    private router: Router,
    public _listService: ListService,
  ) {
    this.contentHeader = {
      headerTitle: italian.data.BILLING_FREQUENCIES,
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: italian.data.MENU.MANAGE,
            isLink: true,
            link: "/dashboard/platform-management",
          },
          {
            name: italian.data.BILLING_FREQUENCIES,
            isLink: false,
          },
        ],
      },
    };
  }

  async ngOnInit() {
    if (!this._authenticationService.hasCapability("show_menu_billing_frequency_list")) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    await this.loadBillingFrequency();
  }

  async loadBillingFrequency() {
    this.billingFrequencyList = await this._listService.getList("billing_frequency");
    this.billingFrequencyFilter();
  }

  updateTableLimit(event: { target: { value: string } }) {
    this.tableLimit = Number(event.target.value);
  }

  billingFrequencyFilter() {
    let items: IBillingFrequency[] = this.billingFrequencyList;
    const keywords: string = this.searchKeyword.trim().toLowerCase();

    if (keywords.length > 0) {
      items = this.billingFrequencyList.filter((item: IBillingFrequency) => item.name.toLowerCase().includes(this.searchKeyword.trim().toLowerCase()));
    }

    this.filteredBillingFrequencyList = items;
  }

  public modalOpen(whichModal, billingFrequency: IBillingFrequency) {
    this.showModalError = false;
    this.billingFrequency = {
      name: null,
      other: {
        month_value: null,
      },
    };
    if (!!billingFrequency) {
      this.billingFrequency = {
        id: billingFrequency.id,
        name: billingFrequency.name,
        other: {
          month_value: billingFrequency.other.month_value,
        },
      };
    }
    this._modalService.open(whichModal, {
      size: "sm",
      centered: true,
    });
  }

  isError(): boolean {
    if (
      !this.billingFrequency.name ||
      this.billingFrequency.name.trim() === "" ||
      this.billingFrequency.name.length < 1 ||
      !this.billingFrequency.other.month_value ||
      this.billingFrequency.other.month_value < 0 ||
      this.billingFrequency.other.month_value > 12
    ) {
      this.showModalError = true;
      return true;
    }
  }

  async deleteBillingFrequency(currentBillingFrequency: { name: string; id?: number }) {
    if (!this._authenticationService.hasCapability("delete_billing_frequency")) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }

    let deleteText: string = await this._utilService.translate("ALERT.CONFIRM_DELETE_TEXT");
    deleteText += await this._utilService.translate("ALERT.CONFIRM_DELETE_THIS_OBJECT");
    deleteText += currentBillingFrequency.name;

    await this._utilService.showSWALDeleteConfirmation({ text: deleteText }).then(async (result) => {
      if (result.value) {
        await this._listService
          .delete(currentBillingFrequency.id, "billing_frequency")
          .then(async () => {
            await this._utilService.showPopupItemDeleted().then(async () => {
              await this.loadBillingFrequency();
            });
          })
          .catch(() => this._utilService.showSWALError({ text: "ERROR_BILLING_FREQUENCY_REMOVE" }));
      } else if (result.isDismissed) {
        await this._utilService.showSWALError({
          title: "ABORTED_TITLE",
          text: "ABORTED_TEXT",
        });
      }
    });
  }

  async addBillingFrequency() {
    if (!this._authenticationService.hasCapability("create_billing_frequency")) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }

    if (this.isError()) {
      return false;
    }

    const data: IBillingFrequency = {
      name: this.billingFrequency.name.trim(),
      other: {
        month_value: this.billingFrequency.other.month_value,
      },
    };

    this._utilService.showLoading();
    await this._listService
      .create(data, "billing_frequency")
      .then(() => {
        this.loadBillingFrequency();
        this._modalService.dismissAll();
        this._utilService.hideLoading();
        this.billingFrequencyFilter();
        this._utilService.showSWALSuccess({ text: "SUCCESS_UPLOAD_BILLING_FREQUENCY" });
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_BILLING_FREQUENCY_INSERT" });
      });
  }

  async editBillingFrequency() {
    if (!this._authenticationService.hasCapability("edit_billing_frequency")) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }

    if (this.isError()) {
      return false;
    }

    const data: IBillingFrequency = {
      name: this.billingFrequency.name.trim(),
      other: {
        month_value: this.billingFrequency.other.month_value,
      },
    };

    this._utilService.showLoading();
    await this._listService
      .update(this.billingFrequency.id, data, "billing_frequency")
      .then(() => {
        this._utilService.hideLoading();
        this.loadBillingFrequency();
        this.billingFrequencyFilter();
        this._modalService.dismissAll();
        this._utilService.showSWALSuccess({ text: "SUCCESS_EDIT_BILLING_FREQUENCY" });
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_BILLING_FREQUENCY_EDIT" });
      });
  }
}
